<template>
  <section class="mx-auto flex min-h-[70vh] max-w-3xl flex-col gap-8 px-0 py-10 sm:px-6">

    <!-- <router-link
      to="/tournament"
      class="mx-6 block overflow-hidden rounded-[2rem] border border-white/10 bg-[radial-gradient(circle_at_top_left,_rgba(245,158,11,0.22),_transparent_30%),radial-gradient(circle_at_bottom_right,_rgba(34,197,94,0.16),_transparent_30%),rgba(15,23,42,0.92)] p-6 transition hover:border-white/20 sm:mx-0"
    >
      <div class="flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between">
        <div class="max-w-2xl">
          <p class="text-xs uppercase tracking-[0.35em] text-amber-200/80">DRVN Champions League</p>
          <h2 class="mt-2 font-display text-3xl font-semibold text-white">Tournament rooms are live</h2>
          <p class="mt-3 text-sm leading-6 text-steel-200">
            Join one of 8 opening rooms, post your car photo and specs, then let the community vote each matchup down to a single champion.
          </p>
        </div>
        <span class="inline-flex items-center justify-center rounded-2xl bg-white px-4 py-3 text-xs font-semibold uppercase tracking-[0.3em] text-midnight-900">
          Open bracket
        </span>
      </div>
    </router-link> -->

    <!-- Top 5 users by likes (click opens profile). Scrollable on small devices. -->
    <div class="mt-1 px-6 sm:px-0">
      <div class="flex items-center justify-between">
        <p class="text-xs uppercase tracking-[0.35em] text-steel-400">{{ $t('feedPage.topMembers') }}</p>
        <p v-if="topUsersLoading" class="text-xs text-steel-400">{{ $t('feedPage.loading') }}</p>
      </div>

      <div
        ref="topUsersScroller"
        class="top-users-scroller mt-3 -mx-4 overflow-x-auto px-4 no-scrollbar"
        @pointerdown="startTopUsersDrag"
      >
        <div v-if="topUsersLoading" class="flex gap-4">
          <div
            v-for="item in 4"
            :key="`top-skeleton-${item}`"
            class="flex-shrink-0 w-44 rounded-2xl border border-white/10 bg-midnight-900/60 px-4 py-3 shadow animate-pulse"
          >
            <div class="flex items-center gap-3">
              <div class="h-12 w-12 rounded-full border-2 border-white/10 bg-white/10"></div>
              <div class="min-w-0 flex-1 space-y-2">
                <div class="h-3 rounded bg-white/10"></div>
                <div class="h-2 w-2/3 rounded bg-white/10"></div>
                <div class="h-2 w-1/2 rounded bg-white/10"></div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="flex gap-4">
          <router-link
            v-for="user in topUsers"
            :key="user.id"
            :to="`/u/${user.handle}`"
            class="flex-shrink-0 w-44 rounded-2xl border border-white/10 bg-midnight-900/60 px-4 py-3 shadow hover:border-white/20"
            @click="handleTopUserCardClick"
          >
            <div class="flex items-center gap-3">
              <div class="relative">
                <div class="h-12 w-12 overflow-hidden rounded-full border-2 border-white/10 bg-midnight-900/70">
                  <img
                    v-if="user.avatar"
                    :src="user.avatar"
                    alt=""
                    class="h-full w-full object-cover"
                    referrerpolicy="no-referrer"
                    crossorigin="anonymous"
                  />
                  <div v-else class="flex h-full w-full items-center justify-center text-sm font-semibold text-steel-200">{{ user.initials }}</div>
                </div>
                <div
                  class="absolute -right-2 -top-2 flex h-6 w-6 items-center justify-center rounded-full text-[11px] font-semibold"
                  :class="user.rank === 1 ? 'bg-yellow-400 text-black' : user.rank === 2 ? 'bg-slate-300 text-black' : user.rank === 3 ? 'bg-amber-700 text-white' : 'bg-white/5 text-white'"
                >
                  {{ user.rank }}
                </div>
              </div>
              <div class="min-w-0">
                <div class="flex items-center gap-1.5">
                  <p class="truncate text-sm text-white">{{ user.fullName }}</p>
                  <verified-badge v-if="user.verified" size="xs" />
                </div>
                <p class="text-xs text-steel-400">@{{ user.handle }}</p>
                <p class="mt-1 text-xs text-steel-400">{{ user.likeCount }} {{ $t('feedPage.likesSuffix') }}</p>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <!-- <div class="px-6 sm:px-0">
      <div class="overflow-hidden rounded-[2rem] border border-white/10 bg-[radial-gradient(circle_at_top_left,_rgba(125,249,255,0.15),_transparent_30%),radial-gradient(circle_at_bottom_right,_rgba(244,114,182,0.12),_transparent_35%),rgba(16,17,20,0.92)] p-6 shadow-glow">
        <div class="flex flex-col gap-6 xl:flex-row xl:items-end xl:justify-between">
          <div class="max-w-2xl">
            <p class="text-xs uppercase tracking-[0.35em] text-neon-300/80">Community Pulse</p>
            <h2 class="mt-2 font-display text-3xl font-semibold text-white sm:text-4xl">
              Make the next post feel like an event.
            </h2>
            <p class="mt-3 text-sm leading-6 text-steel-200">
              {{ dailyPrompt.description }}
            </p>
            <div class="mt-5 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
              <button
                type="button"
                class="w-full rounded-2xl bg-white px-5 py-3 text-xs font-semibold uppercase tracking-[0.3em] text-midnight-900 transition hover:bg-neon-400 sm:w-auto"
                @click="openNewPostModal"
              >
                Post your build
              </button>
              <button
                type="button"
                class="w-full rounded-2xl border border-white/15 bg-white/5 px-5 py-3 text-xs font-semibold uppercase tracking-[0.3em] text-white transition hover:border-white/30 hover:bg-white/10 sm:w-auto"
                @click="activeFeedFilter = 'selling'"
              >
                Browse for sale
              </button>
            </div>
          </div>

          <div class="grid w-full gap-3 md:grid-cols-2 xl:max-w-xl">
            <div
              v-for="stat in pulseStats"
              :key="stat.label"
              class="min-w-0 rounded-2xl border border-white/10 bg-black/20 px-4 py-4"
            >
              <p class="text-[10px] uppercase tracking-[0.3em] text-steel-400">{{ stat.label }}</p>
              <p class="mt-2 break-words text-2xl font-semibold leading-tight text-white">{{ stat.value }}</p>
              <p class="mt-1 break-words text-xs text-steel-300">{{ stat.caption }}</p>
            </div>
            <div class="min-w-0 rounded-2xl border border-white/10 bg-black/20 px-4 py-4 md:col-span-2">
              <p class="text-[10px] uppercase tracking-[0.3em] text-steel-400">Lead Driver</p>
              <div v-if="leadDriver" class="mt-3 flex items-center gap-3 sm:gap-4">
                <router-link
                  :to="`/u/${leadDriver.handle}`"
                  class="block overflow-hidden rounded-full border border-white/10 bg-midnight-900/70 transition hover:border-white/30"
                  aria-label="Open lead driver profile"
                >
                  <img
                    v-if="leadDriver.avatar"
                    :src="leadDriver.avatar"
                    alt=""
                    class="h-14 w-14 object-cover sm:h-16 sm:w-16"
                    referrerpolicy="no-referrer"
                    crossorigin="anonymous"
                  />
                  <div
                    v-else
                    class="flex h-14 w-14 items-center justify-center text-sm font-semibold text-steel-200 sm:h-16 sm:w-16"
                  >
                    {{ leadDriver.initials }}
                  </div>
                </router-link>
                <div class="min-w-0 flex-1">
                  <p class="text-base font-semibold text-white sm:text-lg">Community favorite</p>
                  <p class="mt-1 text-sm text-steel-300">{{ leadDriver.likeCount }} likes earned</p>
                </div>
              </div>
              <p v-else class="mt-3 text-xs text-steel-300">community leaderboard is warming up</p>
            </div>
          </div>
        </div>

        <div class="mt-6 grid gap-3 xl:grid-cols-[1.1fr_0.9fr]">
          <div class="min-w-0 rounded-2xl border border-white/10 bg-black/20 p-4">
            <p class="text-[10px] uppercase tracking-[0.3em] text-steel-400">Challenge of the day</p>
            <p class="mt-2 text-base font-semibold text-white">{{ dailyPrompt.title }}</p>
            <p class="mt-2 text-sm text-steel-300">
              Posteaza un cadru, un setup sau un detail shot care raspunde la tema zilei si tine feed-ul viu.
            </p>
          </div>

          <div class="min-w-0 rounded-2xl border border-white/10 bg-black/20 p-4">
            <p class="text-[10px] uppercase tracking-[0.3em] text-steel-400">Spotlight now</p>
            <div
              v-if="spotlightPost"
              class="mt-3 min-w-0 rounded-2xl border border-white/10 bg-white/[0.03] p-4"
            >
              <div class="flex items-center gap-3">
                <router-link
                  :to="`/u/${spotlightPost.authorHandle}`"
                  class="block overflow-hidden rounded-full border border-white/10 bg-midnight-900/70 transition hover:border-white/30"
                  aria-label="Open spotlight profile"
                >
                  <img
                    v-if="spotlightPost.authorAvatar"
                    :src="spotlightPost.authorAvatar"
                    alt=""
                    class="h-12 w-12 object-cover"
                    referrerpolicy="no-referrer"
                    crossorigin="anonymous"
                  />
                  <div
                    v-else
                    class="flex h-12 w-12 items-center justify-center text-sm font-semibold text-steel-200"
                  >
                    {{ spotlightPost.authorInitials }}
                  </div>
                </router-link>
                <div class="min-w-0 flex-1">
                  <p class="text-sm font-semibold text-white">Spotlight build</p>
                  <p class="mt-1 text-xs text-steel-300">{{ spotlightPost.likeCount }} likes</p>
                </div>
                <router-link
                  :to="`/post/${spotlightPost.id}`"
                  class="rounded-full border border-white/10 px-3 py-2 text-[10px] font-semibold uppercase tracking-[0.26em] text-white transition hover:border-white/25 hover:bg-white/5"
                >
                  View post
                </router-link>
              </div>
              <p class="mt-3 break-words text-sm text-steel-200">{{ spotlightPost.caption || 'Fresh build on the wall.' }}</p>
            </div>
            <div v-else class="mt-3 rounded-2xl border border-dashed border-white/10 px-4 py-5 text-sm text-steel-300">
              Primul post bun de azi poate fi chiar al tau.
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="px-6 sm:px-0">
      <div class="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div class="flex flex-col gap-2">
          <p class="text-xs uppercase tracking-[0.35em] text-steel-400">{{ $t('feedPage.eyebrow') }}</p>
          <h1 class="font-display text-3xl font-semibold tracking-tight text-white sm:text-4xl">
            {{ $t('feedPage.title') }}
          </h1>
          <p class="text-base text-steel-200/90">
            {{ $t('feedPage.description') }}
          </p>
        </div>
        <div class="flex flex-wrap gap-3 sm:justify-end">
          <button
            type="button"
            class="rounded-2xl border border-white/15 px-4 py-2 text-xs font-semibold uppercase tracking-[0.3em] transition"
            :class="activeFeedFilter === 'feed' ? 'bg-white text-midnight-900' : 'bg-white/5 text-white hover:border-white/30'"
            @click="activeFeedFilter = 'feed'"
          >
            {{ $t('feedPage.feed') }}
          </button>
          <button
            type="button"
            class="rounded-2xl border border-white/15 px-4 py-2 text-xs font-semibold uppercase tracking-[0.3em] transition"
            :class="activeFeedFilter === 'following' ? 'bg-white text-midnight-900' : 'bg-white/5 text-white hover:border-white/30'"
            @click="activeFeedFilter = 'following'"
          >
            {{ $t('feedPage.following') }}
          </button>
          <button
            type="button"
            class="rounded-2xl border border-white/15 px-4 py-2 text-xs font-semibold uppercase tracking-[0.3em] transition"
            :class="activeFeedFilter === 'selling' ? 'bg-white text-midnight-900' : 'bg-white/5 text-white hover:border-white/30'"
            @click="activeFeedFilter = 'selling'"
          >
            {{ $t('feedPage.forSale') }}
          </button>
          <button
            type="button"
            class="rounded-2xl border border-white/15 px-4 py-2 text-xs font-semibold uppercase tracking-[0.3em] transition"
            :class="activeFeedFilter === 'saved' ? 'bg-white text-midnight-900' : 'bg-white/5 text-white hover:border-white/30'"
            @click="activeFeedFilter = 'saved'"
          >
            {{ $t('feedPage.saved') }}
          </button>
          <!-- <button
            type="button"
            class="rounded-2xl border border-white/15 px-4 py-2 text-xs font-semibold uppercase tracking-[0.3em] transition"
            :class="activeFeedFilter === 'local' ? 'bg-white text-midnight-900' : 'bg-white/5 text-white hover:border-white/30'"
            @click="activeFeedFilter = 'local'"
          >
            Local
          </button> -->
        </div>
      </div>
    </div>

    <div class="px-6 sm:px-0">
      <div class="grid gap-4 xl:grid-cols-[1.1fr_0.9fr]">
        <div class="feed-premium-card feed-build-card overflow-hidden rounded-[2rem] border border-white/10 bg-[linear-gradient(145deg,rgba(12,18,27,0.95),rgba(17,25,38,0.92))] p-5 shadow-glow">
          <div class="flex items-center justify-between gap-3">
            <div>
              <p class="text-xs uppercase tracking-[0.35em] text-amber-300/85">Build of the week</p>
              <h2 class="mt-2 font-display text-2xl font-semibold text-white">Momentum on the wall</h2>
            </div>
            <span class="rounded-full border border-amber-300/30 bg-amber-300/10 px-3 py-1 text-[10px] uppercase tracking-[0.3em] text-amber-100">Weekly pick</span>
          </div>
          <router-link
            v-if="buildOfTheWeek"
            :to="`/post/${buildOfTheWeek.id}`"
            class="feed-premium-inner mt-5 block overflow-hidden rounded-[1.5rem] border border-white/10 bg-white/[0.03] transition hover:border-white/20"
          >
            <div class="aspect-[16/10] overflow-hidden bg-black">
              <img :src="currentMedia(buildOfTheWeek)" alt="Build of the week" class="h-full w-full object-cover" :style="{ objectPosition: currentMediaPosition(buildOfTheWeek) }" />
            </div>
            <div class="space-y-3 p-4">
              <div class="flex items-center gap-3">
                <div class="h-11 w-11 overflow-hidden rounded-full border border-white/10 bg-midnight-900/70">
                  <img v-if="buildOfTheWeek.authorAvatar" :src="buildOfTheWeek.authorAvatar" alt="" class="h-full w-full object-cover" referrerpolicy="no-referrer" crossorigin="anonymous" />
                  <div v-else class="flex h-full w-full items-center justify-center text-sm font-semibold text-steel-200">{{ buildOfTheWeek.authorInitials }}</div>
                </div>
                <div class="min-w-0">
                  <div class="flex items-center gap-1.5">
                    <p class="truncate text-sm font-semibold text-white">{{ buildOfTheWeek.authorName }}</p>
                    <verified-badge v-if="buildOfTheWeek.authorVerified" size="xs" />
                  </div>
                  <p class="text-xs text-steel-400">@{{ buildOfTheWeek.authorHandle }}</p>
                </div>
              </div>
              <p class="text-base font-semibold text-white">{{ buildOfTheWeek.caption || 'Fresh build on the rise.' }}</p>
              <div class="flex flex-wrap gap-2 text-xs text-steel-300">
                <span class="rounded-full border border-white/10 bg-white/[0.03] px-3 py-1">{{ buildOfTheWeek.likeCount }} likes</span>
                <span class="rounded-full border border-white/10 bg-white/[0.03] px-3 py-1">{{ buildOfTheWeek.viewCount }} views</span>
                <span v-if="buildOfTheWeek.car_make || buildOfTheWeek.car_model" class="rounded-full border border-white/10 bg-white/[0.03] px-3 py-1">
                  {{ [buildOfTheWeek.car_make, buildOfTheWeek.car_model].filter(Boolean).join(' ') }}
                </span>
              </div>
            </div>
          </router-link>
          <div v-else class="mt-5 rounded-[1.5rem] border border-dashed border-white/10 px-5 py-8 text-sm text-steel-400">
            The first standout build of the week will be highlighted here automatically.
          </div>
        </div>

        <div class="feed-premium-card feed-leaderboard-card overflow-hidden rounded-[2rem] border border-white/10 bg-midnight-900/55 p-4 shadow-glow sm:p-5">
          <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div class="min-w-0">
              <p class="text-xs uppercase tracking-[0.35em] text-steel-400">Weekly leaderboard</p>
              <h2 class="mt-2 max-w-[10rem] font-display text-2xl font-semibold leading-tight text-white sm:max-w-none">Top members this week</h2>
            </div>
            <span class="max-w-[12rem] text-xs leading-5 text-steel-400 sm:max-w-[11rem] sm:text-right">Auto-scored by likes, reactions, and views</span>
          </div>
          <div v-if="weeklyTopMembers.length" class="mt-5 space-y-3">
            <router-link
              v-for="member in weeklyTopMembers"
              :key="member.id"
              :to="`/u/${member.handle}`"
              class="feed-leaderboard-row relative grid grid-cols-[auto_minmax(0,1fr)] gap-3 rounded-[1.25rem] border border-white/10 bg-white/[0.03] px-3 py-3 transition hover:border-white/20 sm:flex sm:items-center"
            >
              <div
                class="absolute -left-2 -top-2 flex h-6 w-6 items-center justify-center rounded-full text-[11px] font-semibold"
                :class="member.rank === 1 ? 'bg-yellow-400 text-black' : member.rank === 2 ? 'bg-slate-300 text-black' : member.rank === 3 ? 'bg-amber-700 text-white' : 'bg-white/5 text-white'"
              >
                {{ member.rank }}
              </div>
              <div class="h-10 w-10 overflow-hidden rounded-full border border-white/10 bg-midnight-900/70">
                <img v-if="member.avatar" :src="member.avatar" alt="" class="h-full w-full object-cover" referrerpolicy="no-referrer" crossorigin="anonymous" />
                <div v-else class="flex h-full w-full items-center justify-center text-sm font-semibold text-steel-200">{{ member.initials }}</div>
              </div>
              <div class="min-w-0">
                <div class="flex items-center gap-1.5">
                  <p class="truncate text-sm font-semibold text-white">{{ member.fullName }}</p>
                  <verified-badge v-if="member.verified" size="xs" />
                </div>
                <p class="text-xs text-steel-400">@{{ member.handle }}</p>
              </div>
              <div class="col-span-2 flex items-center justify-between border-t border-white/5 pt-2 sm:col-span-1 sm:ml-auto sm:block sm:border-t-0 sm:pt-0 sm:text-right">
                <p class="text-sm font-semibold text-white">{{ member.score }}</p>
                <p class="text-[10px] uppercase tracking-[0.22em] text-steel-400">{{ member.likes }} likes</p>
              </div>
            </router-link>
          </div>
          <p v-else class="mt-5 text-sm text-steel-400">Once this week’s engagement starts stacking up, the leaderboard will fill in here.</p>
        </div>
      </div>
    </div>

    <div v-if="initialLoading" class="grid gap-3 px-6 sm:px-0">
      <div
        v-for="item in 2"
        :key="`feed-skeleton-${item}`"
        class="overflow-hidden bg-midnight-800/60 animate-pulse sm:rounded-2xl sm:shadow-glow"
      >
        <div class="flex items-center gap-3 px-4 py-3">
          <div class="h-10 w-10 rounded-full bg-white/10"></div>
          <div class="flex-1 space-y-2">
            <div class="h-3 w-40 rounded bg-white/10"></div>
            <div class="h-2 w-24 rounded bg-white/10"></div>
          </div>
        </div>
        <div class="aspect-square w-full bg-white/5"></div>
        <div class="space-y-3 px-4 py-4">
          <div class="flex gap-3">
            <div class="h-5 w-5 rounded bg-white/10"></div>
            <div class="h-5 w-5 rounded bg-white/10"></div>
            <div class="h-5 w-5 rounded bg-white/10"></div>
          </div>
          <div class="h-3 w-24 rounded bg-white/10"></div>
          <div class="h-3 w-5/6 rounded bg-white/10"></div>
          <div class="h-2 w-20 rounded bg-white/10"></div>
        </div>
      </div>
    </div>

    <div v-else class="grid gap-0 sm:gap-3">
      <router-link
        v-for="post in filteredPosts"
        :key="post.id"
        :to="`/post/${post.id}`"
        class="block overflow-hidden bg-midnight-800/60 transition hover:border-white/20 rounded-none shadow-none sm:rounded-2xl sm:shadow-glow"
      >
        <!-- Header (avatar, name, menu) -->
        <div class="flex items-center gap-3 px-4 py-3">
          <div class="h-10 w-10 overflow-hidden rounded-full border border-white/10 bg-midnight-900/70">
            <img
              v-if="post.authorAvatar"
              :src="post.authorAvatar"
              alt="Author avatar"
              class="h-full w-full object-cover"
              referrerpolicy="no-referrer"
              crossorigin="anonymous"
            />
            <div v-else class="flex h-full w-full items-center justify-center text-sm font-semibold text-steel-200">{{ post.authorInitials }}</div>
          </div>
          <div class="min-w-0">
            <div class="flex items-center gap-1.5">
              <p class="text-sm font-semibold text-white">{{ post.authorName }}</p>
              <verified-badge v-if="post.authorVerified" size="xs" />
            </div>
            <router-link class="text-xs text-steel-400 hover:text-white" :to="`/u/${post.authorHandle}`">@{{ post.authorHandle }}</router-link>
          </div>
          <button
            v-if="shouldShowFollowButton(post.user_id)"
            type="button"
            class="ml-auto rounded-full border px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.28em] transition"
            :class="isFollowingAuthor(post.user_id) ? 'border-white/15 bg-white/5 text-steel-300 hover:border-white/30 hover:text-white' : 'border-white bg-white text-midnight-900 hover:bg-neon-400'"
            @click.stop.prevent="toggleFollow(post)"
          >
            {{ isFollowingAuthor(post.user_id) ? 'Following' : 'Follow' }}
          </button>
          <button
            type="button"
            class="text-steel-400 hover:text-white"
            @click.stop.prevent="openReportModal(post)"
          >
            ⋯
          </button>
        </div>

        <!-- Image (consistent aspect ratio) -->
        <div
          class="relative aspect-square w-full bg-black"
          style="touch-action: pan-y;"
          @touchstart="handleSwipeStart($event)"
          @touchend="handleSwipeEnd($event, post)"
        >
          <transition :name="post.mediaDirection === 'prev' ? 'media-swipe-prev' : 'media-swipe-next'" mode="out-in">
            <img
              :key="currentMedia(post)"
              :src="currentMedia(post)"
              alt="Post"
              class="absolute inset-0 h-full w-full object-cover"
              :style="{ objectPosition: currentMediaPosition(post) }"
            />
          </transition>

          <div v-if="post.mediaUrls.length > 1" class="absolute bottom-3 left-1/2 -translate-x-1/2 flex items-center gap-1 z-10 pointer-events-none">
            <button
              v-for="(url, idx) in post.mediaUrls"
              :key="idx"
              type="button"
              class="h-1 rounded-full transition-all pointer-events-auto"
              :class="idx === post.mediaIndex ? 'w-6 bg-white' : 'w-1 bg-white/40'"
              @click="setMediaIndex(post, idx)"
            />
          </div>
        </div>

        <!-- Actions and meta -->
        <div class="px-4 py-3">
          <div class="flex items-center gap-3">
            <button type="button" class="inline-flex items-center gap-2" :class="post.isLiked ? 'text-rose-500' : 'text-white'" @click.stop.prevent="toggleLike(post)">
              <svg class="h-6 w-6" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M12 21s-6.7-4.3-9.3-7.6C.5 10.8 1 7.6 3 5.7c2-2 5.2-1.6 7 0l2 1.9 2-1.9c1.8-1.6 5-2 7 0 2 1.9 2.5 5.1.3 7.7C18.7 16.7 12 21 12 21z" />
              </svg>
            </button>
            <button type="button" class="inline-flex items-center gap-2 text-steel-400 hover:text-white" aria-label="Comments">
              <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
            <button type="button" class="inline-flex items-center gap-2" @click.stop.prevent="sharePost(post)">
              <svg class="h-6 w-6 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12 3v13" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M8 7l4-4 4 4" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
            <div class="ml-auto">
              <button type="button" class="p-1 text-steel-400 hover:text-white" @click.stop.prevent="toggleBookmark(post)">
                <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path
                    d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"
                    stroke-width="1.6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    :fill="isBookmarked(post.id) ? 'currentColor' : 'none'"
                    :class="isBookmarked(post.id) ? 'text-neon-400' : ''"
                  />
                </svg>
              </button>
            </div>
          </div>

          <div class="mt-2 flex flex-wrap items-center gap-3 text-sm font-semibold text-white">
            <p>{{ post.likeCount }} likes</p>
            <p class="text-steel-300">{{ post.saveCount || 0 }} saves</p>
          </div>

          <div class="mt-3">
            <div class="grid grid-cols-3 gap-2">
              <button
                v-for="reaction in reactionOptions"
                :key="reaction.type"
                type="button"
                class="flex min-h-[52px] items-center justify-between gap-2 rounded-2xl border px-3 py-2 text-left transition"
                :class="reactionButtonClass(post, reaction.type)"
                @click.stop.prevent="toggleReaction(post, reaction.type)"
              >
                <span class="min-w-0">
                  <span class="block text-[10px] uppercase tracking-[0.26em]">{{ reaction.label }}</span>
                  <span class="mt-1 block text-xs opacity-80">{{ reaction.shortLabel }}</span>
                </span>
                <span class="shrink-0 text-sm font-semibold">{{ getReactionCount(post, reaction.type) }}</span>
              </button>
            </div>
            <p class="mt-2 text-xs text-steel-400">
              <span v-if="post.userReaction">Your reaction: {{ reactionLabel(post.userReaction) }}</span>
              <span v-else>Tap a reaction to give the post more personality.</span>
              <span class="ml-2 text-steel-300">{{ post.totalReactionCount || 0 }} reactions</span>
            </p>
          </div>

          <p class="mt-1 text-sm text-steel-200">
            <span class="font-semibold text-white">@{{ post.authorHandle }}</span>
            <span class="ml-1">{{ post.caption }}</span>
          </p>

          <div v-if="postMetaBadges(post).length || post.tags?.length || post.car_make || post.car_model || post.edited_at" class="mt-3 flex flex-wrap gap-2">
            <span
              v-for="badge in postMetaBadges(post)"
              :key="`${post.id}-${badge.label}`"
              class="rounded-full border px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.26em]"
              :class="badge.tone"
            >
              {{ badge.label }}
            </span>
            <span
              v-if="post.car_make || post.car_model"
              class="rounded-full border border-white/10 bg-white/[0.03] px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.26em] text-steel-200"
            >
              {{ [post.car_make, post.car_model].filter(Boolean).join(' ') }}
            </span>
            <span
              v-for="tag in (post.tags || []).slice(0, 4)"
              :key="`${post.id}-${tag}`"
              class="rounded-full border border-white/10 bg-white/[0.03] px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.26em] text-steel-300"
            >
              #{{ tag }}
            </span>
            <span
              v-if="post.edited_at"
              class="rounded-full border border-white/10 bg-white/[0.03] px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.26em] text-steel-400"
            >
              edited
            </span>
          </div>

          <p v-if="post.commentCount" class="mt-2 text-xs text-steel-400">View all {{ post.commentCount }} comments</p>

          <p class="mt-2 text-xs text-steel-400">{{ post.viewCount || 0 }} views</p>
          <p class="mt-1 text-xs text-steel-400">{{ post.createdLabel }}</p>
        </div>
      </router-link>
    </div>

    <div
      v-if="!initialLoading && !filteredPosts.length"
      class="mx-6 rounded-3xl border border-white/10 bg-midnight-800/40 px-6 py-10 text-center sm:mx-0"
    >
      <p class="text-xs uppercase tracking-[0.35em] text-steel-400">
        {{ activeFeedFilter === 'following' ? 'Following feed' : activeFeedFilter === 'selling' ? 'For sale feed' : 'Feed' }}
      </p>
      <p class="mt-3 text-sm text-steel-300">
        {{ emptyFeedMessage }}
      </p>
    </div>

    <div v-if="!initialLoading && loadingMorePosts" class="px-6 sm:px-0">
      <div class="overflow-hidden bg-midnight-800/60 animate-pulse sm:rounded-2xl sm:shadow-glow">
        <div class="flex items-center gap-3 px-4 py-3">
          <div class="h-10 w-10 rounded-full bg-white/10"></div>
          <div class="flex-1 space-y-2">
            <div class="h-3 w-40 rounded bg-white/10"></div>
            <div class="h-2 w-24 rounded bg-white/10"></div>
          </div>
        </div>
        <div class="aspect-square w-full bg-white/5"></div>
        <div class="space-y-3 px-4 py-4">
          <div class="h-3 w-24 rounded bg-white/10"></div>
          <div class="h-3 w-5/6 rounded bg-white/10"></div>
        </div>
      </div>
    </div>

    <div
      v-if="!initialLoading && hasMorePosts"
      ref="feedSentinel"
      class="h-10 w-full"
      aria-hidden="true"
    ></div>

    <p v-if="errorMessage" class="mx-6 rounded-2xl border border-rose-500/30 bg-rose-500/10 px-4 py-3 text-sm text-rose-100 sm:mx-0">
      {{ errorMessage }}
    </p>

    <div
      v-if="showWelcomeModal"
      class="fixed inset-0 z-[140] flex items-center justify-center bg-black/70 px-6"
      @click.self="dismissWelcomeModal"
    >
      <div class="w-full max-w-md rounded-3xl border border-white/10 bg-midnight-900/95 p-6 shadow-glow">
        <p class="text-xs uppercase tracking-[0.35em] text-steel-400">Welcome</p>
        <h3 class="mt-2 font-display text-2xl font-semibold text-white">Bine ai venit in comunitate</h3>
        <div class="mt-5 flex items-center gap-4 rounded-2xl border border-white/10 bg-white/[0.03] p-4">
          <div class="flex h-14 w-14 items-center justify-center overflow-hidden rounded-2xl border border-white/10 bg-midnight-800 text-lg font-semibold text-white">
            GV
          </div>
          <div class="min-w-0">
            <p class="text-base font-semibold text-white">Gabriel Valentin</p>
            <p class="text-sm text-steel-400">@sk3r0r</p>
          </div>
        </div>
        <p class="mt-4 text-sm leading-6 text-steel-300">
          Bine ai venit in comunitate. Ma bucur ca esti aici, sper sa iti postezi masina, proiectele si sa cunosti oameni faini din DRVN.
        </p>
        <div class="mt-6 flex justify-end">
          <button
            type="button"
            class="rounded-2xl bg-white px-4 py-2 text-xs font-semibold uppercase tracking-[0.3em] text-midnight-900 transition hover:bg-neon-400"
            @click="dismissWelcomeModal"
          >
            Intra in feed
          </button>
        </div>
      </div>
    </div>

    <div
      v-if="showReportModal"
      class="fixed inset-0 z-[140] flex items-center justify-center bg-black/70 px-6"
      @click.self="closeReportModal"
    >
      <div class="w-full max-w-md rounded-3xl border border-white/10 bg-midnight-900/95 p-6 shadow-glow">
        <div class="flex items-center justify-between">
          <h3 class="font-display text-lg font-semibold text-white">Report post</h3>
          <button
            type="button"
            class="rounded-full border border-white/10 px-3 py-1 text-xs uppercase tracking-[0.3em] text-steel-300 hover:text-white"
            @click="closeReportModal"
          >
            Close
          </button>
        </div>
        <p class="mt-3 text-xs text-steel-400">Tell us what is wrong with this post.</p>
        <textarea
          v-model.trim="reportReason"
          rows="4"
          maxlength="500"
          placeholder="Reason (e.g. nude content, spam, harassment)"
          class="mt-3 w-full resize-none rounded-2xl border border-white/10 bg-midnight-900/60 px-4 py-3 text-sm text-white placeholder:text-steel-500 focus:border-rose-400/70 focus:outline-none focus:ring-2 focus:ring-rose-400/30"
        ></textarea>
        <div class="mt-3 flex items-center justify-between">
          <p v-if="reportError" class="text-xs text-rose-300">{{ reportError }}</p>
          <p v-if="reportStatus" class="text-xs text-neon-300">{{ reportStatus }}</p>
          <button
            type="button"
            class="ml-auto rounded-full bg-white px-4 py-2 text-[10px] uppercase tracking-[0.3em] text-midnight-900 transition hover:bg-rose-300 disabled:cursor-not-allowed disabled:opacity-70"
            :disabled="reportSubmitting || !reportReason"
            @click="submitReport"
          >
            {{ reportSubmitting ? 'Sending...' : 'Send report' }}
          </button>
        </div>
      </div>
    </div>

    <div
      v-if="showLikesModal"
      class="fixed inset-0 z-[140] flex items-center justify-center bg-black/70 px-6"
      @click.self="closeLikesModal"
    >
      <div class="w-full max-w-md rounded-3xl border border-white/10 bg-midnight-900/95 p-6 shadow-glow">
        <div class="flex items-center justify-between">
          <h3 class="font-display text-lg font-semibold text-white">Likes</h3>
          <button
            type="button"
            class="rounded-full border border-white/10 px-3 py-1 text-xs uppercase tracking-[0.3em] text-steel-300 hover:text-white"
            @click="closeLikesModal"
          >
            Close
          </button>
        </div>
        <p v-if="likesLoading" class="mt-4 text-sm text-steel-300">Loading...</p>
        <p v-else-if="likesError" class="mt-4 text-sm text-rose-200">{{ likesError }}</p>
        <p v-else-if="!likesUsers.length" class="mt-4 text-sm text-steel-300">No likes yet.</p>
        <div v-else class="mt-4 space-y-3">
          <router-link
            v-for="user in likesUsers"
            :key="user.id"
            :to="`/u/${user.handle}`"
            class="flex items-center gap-3 rounded-2xl border border-white/10 bg-midnight-900/60 px-3 py-2 hover:border-white/20"
            @click="closeLikesModal"
          >
            <div class="h-10 w-10 overflow-hidden rounded-full border border-white/10 bg-midnight-900/70">
              <img
                v-if="user.avatar"
                :src="user.avatar"
                alt=""
                class="h-full w-full object-cover"
                referrerpolicy="no-referrer"
                crossorigin="anonymous"
              />
              <div v-else class="flex h-full w-full items-center justify-center text-sm font-semibold text-steel-200">
                {{ user.initials }}
              </div>
            </div>
            <div class="min-w-0">
              <div class="flex items-center gap-1.5">
                <p class="truncate text-sm text-white">{{ user.fullName }}</p>
                <verified-badge v-if="user.verified" size="xs" />
              </div>
              <p class="text-[10px] uppercase tracking-[0.3em] text-steel-400">@{{ user.handle }}</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <!-- Desktop new post button -->
    <button
      type="button"
      class="hidden fixed z-50 right-6 bottom-6 sm:inline-flex items-center justify-center gap-2 rounded-2xl bg-white px-4 py-3 text-xs font-semibold uppercase tracking-[0.3em] text-midnight-900 shadow-lg transition hover:bg-neon-400"
      @click="openNewPostModal"
      aria-label="New post"
    >
      <svg class="h-4 w-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      New Post
    </button>

    <div
      v-if="showNewPostModal"
      class="fixed inset-0 z-[140] flex items-end bg-black/75 px-0 pt-10 backdrop-blur-sm sm:items-center sm:justify-center sm:px-6 sm:pt-0"
      @click.self="closeNewPostModal"
    >
      <div class="w-full max-w-2xl overflow-auto rounded-t-[2rem] border border-white/10 bg-[linear-gradient(180deg,rgba(16,22,33,0.98),rgba(11,16,24,0.99))] px-5 py-5 shadow-glow max-h-[calc(100vh-2.5rem)] sm:max-h-[90vh] sm:rounded-3xl sm:p-6">
        <div class="flex items-start justify-between gap-4">
          <div>
            <p class="text-[10px] font-semibold uppercase tracking-[0.28em] text-neon-400">New post</p>
            <h3 class="mt-2 font-display text-2xl font-semibold text-white">Share a fresh build shot</h3>
            <p class="mt-2 max-w-xl text-sm leading-6 text-steel-300">Add photos first, then refine the story, specs and sale status before you publish.</p>
          </div>
          <button
            type="button"
            class="rounded-full border border-white/10 px-3 py-1 text-xs uppercase tracking-[0.3em] text-steel-300 transition hover:border-white/20 hover:text-white"
            @click="closeNewPostModal"
          >
            Close
          </button>
        </div>
        <p v-if="statusMessage" class="mt-4 text-sm text-steel-300">{{ statusMessage }}</p>
        <p v-if="isPosting" class="mt-4 text-sm text-steel-300">Posting...</p>
        <p v-if="errorMessage" class="mt-4 text-sm text-rose-200">{{ errorMessage }}</p>
        <div class="mt-5 space-y-4 pb-[calc(env(safe-area-inset-bottom,0px)+1rem)]">
          <div class="rounded-[1.75rem] border border-white/10 bg-white/[0.03] p-4">
            <p class="text-[10px] uppercase tracking-[0.3em] text-steel-400">Story</p>
            <div class="mt-3 space-y-3">
              <input v-model.trim="newPostCaption" type="text" placeholder="Caption (Optional)" class="w-full rounded-2xl border border-white/10 bg-midnight-900/60 px-4 py-3 text-sm text-white placeholder:text-steel-400 focus:border-neon-400/70 focus:outline-none focus:ring-2 focus:ring-neon-400/30" />
              <textarea v-model.trim="newPostDescription" rows="3" placeholder="Description (Optional)" class="w-full rounded-2xl border border-white/10 bg-midnight-900/60 px-4 py-3 text-sm text-white placeholder:text-steel-400 focus:border-neon-400/70 focus:outline-none focus:ring-2 focus:ring-neon-400/30"></textarea>
              <textarea v-model.trim="newPostModifications" rows="3" placeholder="Car modifications (Optional)" class="w-full rounded-2xl border border-white/10 bg-midnight-900/60 px-4 py-3 text-sm text-white placeholder:text-steel-400 focus:border-neon-400/70 focus:outline-none focus:ring-2 focus:ring-neon-400/30"></textarea>
            </div>
          </div>

          <div class="rounded-[1.75rem] border border-white/10 bg-white/[0.03] p-4">
            <div class="flex items-center justify-between gap-3">
              <p class="text-[10px] uppercase tracking-[0.3em] text-steel-400">Specs</p>
              <label class="inline-flex items-center gap-3 text-[10px] uppercase tracking-[0.24em] text-steel-300">
                <input v-model="newPostForSale" type="checkbox" class="h-4 w-4 rounded border-white/20 bg-midnight-900/60 text-neon-400 focus:ring-neon-400/40" />
                For sale
              </label>
            </div>
            <div class="mt-3 space-y-3">
              <div class="grid gap-3 sm:grid-cols-2">
                <input v-model.trim="newPostMake" type="text" placeholder="Make (Optional)" class="w-full rounded-2xl border border-white/10 bg-midnight-900/60 px-4 py-3 text-sm text-white placeholder:text-steel-400 focus:border-neon-400/70 focus:outline-none focus:ring-2 focus:ring-neon-400/30" />
                <input v-model.trim="newPostModel" type="text" placeholder="Model (Optional)" class="w-full rounded-2xl border border-white/10 bg-midnight-900/60 px-4 py-3 text-sm text-white placeholder:text-steel-400 focus:border-neon-400/70 focus:outline-none focus:ring-2 focus:ring-neon-400/30" />
              </div>
              <input v-model.trim="newPostEngine" type="text" placeholder="Engine (Optional)" class="w-full rounded-2xl border border-white/10 bg-midnight-900/60 px-4 py-3 text-sm text-white placeholder:text-steel-400 focus:border-neon-400/70 focus:outline-none focus:ring-2 focus:ring-neon-400/30" />
              <input v-model.trim="newPostTags" type="text" placeholder="Tags separated by commas (Optional)" class="w-full rounded-2xl border border-white/10 bg-midnight-900/60 px-4 py-3 text-sm text-white placeholder:text-steel-400 focus:border-neon-400/70 focus:outline-none focus:ring-2 focus:ring-neon-400/30" />
              <div class="grid gap-3 sm:grid-cols-3">
                <input v-model.number="newPostHpStock" type="number" min="0" placeholder="HP Stock (Optional)" class="w-full rounded-2xl border border-white/10 bg-midnight-900/60 px-4 py-3 text-sm text-white placeholder:text-steel-400 focus:border-neon-400/70 focus:outline-none focus:ring-2 focus:ring-neon-400/30" />
                <input v-model.number="newPostHpTuned" type="number" min="0" placeholder="HP After Tune (Optional)" class="w-full rounded-2xl border border-white/10 bg-midnight-900/60 px-4 py-3 text-sm text-white placeholder:text-steel-400 focus:border-neon-400/70 focus:outline-none focus:ring-2 focus:ring-neon-400/30" />
                <input v-model.number="newPostYear" type="number" min="1900" max="2100" placeholder="Year (Optional)" class="w-full rounded-2xl border border-white/10 bg-midnight-900/60 px-4 py-3 text-sm text-white placeholder:text-steel-400 focus:border-neon-400/70 focus:outline-none focus:ring-2 focus:ring-neon-400/30" />
              </div>
              <select v-model="newPostStatus" class="w-full rounded-2xl border border-white/10 bg-midnight-900/60 px-4 py-3 text-sm text-white focus:border-neon-400/70 focus:outline-none focus:ring-2 focus:ring-neon-400/30">
                <option value="active">Standard post</option>
                <option value="featured">Featured build</option>
                <option value="contest">Contest entry</option>
              </select>
            </div>
          </div>

          <div class="rounded-[1.75rem] border border-white/10 bg-white/[0.03] p-4">
            <div class="flex items-center justify-between gap-3">
              <div>
                <p class="text-[10px] uppercase tracking-[0.3em] text-steel-400">Media</p>
                <p class="mt-1 text-xs text-steel-400">Upload up to five photos and adjust the crop before going live.</p>
              </div>
              <p v-if="newPostPreviews.length" class="text-xs text-steel-300">{{ newPostPreviews.length }} photo(s) ready.</p>
            </div>
            <label class="mt-4 inline-flex w-full cursor-pointer items-center justify-center gap-3 rounded-2xl border border-white/15 bg-white/5 px-4 py-3 text-xs font-semibold uppercase tracking-[0.3em] text-white transition hover:border-white/30 hover:bg-white/10">
            <input
              ref="newPostFileInput"
              class="absolute left-0 top-0 h-0 w-0 opacity-0"
              type="file"
              accept="image/*"
              multiple
              @change="handlePostUpload"
            />
            Upload photos (max 5)
          </label>
          <div v-if="newPostPreviews.length" class="mt-4 rounded-2xl border border-white/10 bg-midnight-900/60 p-3">
            <p class="text-xs uppercase tracking-[0.3em] text-steel-400">Adjust framing</p>
            <p class="mt-2 text-xs text-steel-400">Drag each photo to position it inside the post crop.</p>
            <div class="mt-3 grid gap-3 sm:grid-cols-2">
              <div
                v-for="(url, idx) in newPostPreviews"
                :key="url + idx"
                class="relative aspect-square w-full overflow-hidden rounded-2xl border border-white/10 bg-black"
                style="touch-action: none;"
                @pointerdown="startPreviewDrag(idx, $event)"
              >
                <img
                  :src="url"
                  alt="Preview"
                  class="h-full w-full select-none object-cover"
                  :style="{ objectPosition: previewPosition(idx) }"
                  draggable="false"
                />
                <div class="pointer-events-none absolute inset-x-0 bottom-2 text-center text-[10px] uppercase tracking-[0.3em] text-white/70">
                  Drag to move
                </div>
              </div>
            </div>
          </div>
          </div>

          <div class="sticky bottom-0 -mx-5 border-t border-white/10 bg-[linear-gradient(180deg,rgba(11,16,24,0),rgba(11,16,24,0.98)_24%)] px-5 pb-[calc(env(safe-area-inset-bottom,0px)+0.25rem)] pt-5 sm:-mx-6 sm:px-6">
            <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
              <p class="text-xs text-steel-400">At least one photo is required to publish.</p>
              <button type="button" class="inline-flex items-center justify-center rounded-2xl bg-white px-5 py-3 text-xs font-semibold uppercase tracking-[0.3em] text-midnight-900 transition hover:bg-neon-400 disabled:cursor-not-allowed disabled:opacity-70 sm:min-w-[220px]" :disabled="isPosting || !isPostValid" @click="publishPost">
                {{ isPosting ? 'Posting...' : 'Publish post' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Floating toast notification (visible on all screen sizes) -->
    <div v-if="statusMessage" class="fixed bottom-6 left-1/2 z-60 -translate-x-1/2 rounded-full bg-neon-400/95 px-4 py-2 text-sm font-semibold text-midnight-900 shadow pointer-events-none">
      {{ statusMessage }}
    </div>
  </section>
</template>

<script>
import { supabase, getAvatarUrl, getPostImageUrl, getReadableSupabaseErrorMessage, refreshReadySession, runSupabaseQueryWithRetry } from '@/lib/supabase'
import { emitAppToast } from '@/lib/toast'
import { createUserNotification } from '@/lib/notifications'
import VerifiedBadge from '@/components/VerifiedBadge.vue'

const REACTION_OPTIONS = [
  { type: 'clean', label: 'Clean', shortLabel: 'polished' },
  { type: 'beast', label: 'Beast', shortLabel: 'aggressive' },
  { type: 'dream_spec', label: 'Dream Spec', shortLabel: 'wishlist' },
]

export default {
  name: 'FeedView',
  components: {
    VerifiedBadge,
  },
  watch: {
    '$route.query.compose': {
      immediate: true,
      handler(value) {
        if (value === '1') {
          this.openNewPostModal()
          this.clearComposeQuery()
        }
      },
    },
  },
  data() {
    return {
      posts: [],
      errorMessage: '',
      statusMessage: '',
      userId: '',
      showLikesModal: false,
      likesLoading: false,
      likesError: '',
      likesUsers: [],
      activeFeedFilter: 'feed',
      showNewPostModal: false,
      newPostCaption: '',
      newPostDescription: '',
      newPostModifications: '',
      newPostEngine: '',
      newPostMake: '',
      newPostModel: '',
      newPostTags: '',
      newPostStatus: 'active',
      newPostHpStock: null,
      newPostHpTuned: null,
      newPostYear: null,
      newPostForSale: false,
      newPostPreviews: [],
      newPostPaths: [],
      newPostOffsets: [],
      previewDrag: null,
      isPosting: false,
      topUsers: [],
      topUsersLoading: false,
      showReportModal: false,
      reportPost: null,
      reportReason: '',
      reportSubmitting: false,
      reportError: '',
      reportStatus: '',
      swipeStartX: 0,
      swipeEndX: 0,
      swipeStartY: 0,
      swipeEndY: 0,
      preloadedImages: {},
      followingIds: [],
      bookmarkIds: [],
      followFeatureReady: true,
      showWelcomeModal: false,
      currentUserCreatedAt: '',
      viewerProfile: null,
      discoveryQuery: '',
      initialLoading: true,
      loadingMorePosts: false,
      hasMorePosts: true,
      pageSize: 4,
      feedPage: 0,
      feedObserver: null,
      topUsersDrag: null,
      topUsersDragged: false,
      visibilityHandler: null,
      isRefreshingView: false,
    }
  },
  computed: {
    filteredPosts() {
      const query = (this.discoveryQuery || '').trim().toLowerCase()
      const matchesQuery = (post) => {
        if (!query) return true
        const haystack = [
          post.caption,
          post.description,
          post.modifications,
          post.engine,
          post.car_make,
          post.car_model,
          post.authorName,
          post.authorHandle,
          post.authorCountry,
          post.authorCity,
          ...(post.tags || []),
        ]
          .filter(Boolean)
          .join(' ')
          .toLowerCase()

        return haystack.includes(query)
      }

      if (this.activeFeedFilter === 'following') {
        return this.posts.filter((post) => !post.is_for_sale && this.isFollowingAuthor(post.user_id) && matchesQuery(post))
      }
      if (this.activeFeedFilter === 'saved') {
        return this.posts.filter((post) => this.isBookmarked(post.id) && matchesQuery(post))
      }
      if (this.activeFeedFilter === 'local') {
        return this.posts.filter((post) => this.isLocalPost(post) && matchesQuery(post))
      }
      if (this.activeFeedFilter === 'selling') {
        return this.posts.filter((post) => post.is_for_sale && matchesQuery(post))
      }
      return this.posts.filter((post) => !post.is_for_sale && matchesQuery(post))
    },
    emptyFeedMessage() {
      if (this.activeFeedFilter === 'following') {
        if (!this.userId) return 'Sign in to build a following feed.'
        if (!this.followFeatureReady) return 'Follow data will appear after the follow table is set up.'
        return 'Follow a few members and their latest builds will show up here.'
      }
      if (this.activeFeedFilter === 'saved') {
        return 'Save a few posts and they will wait here for later.'
      }
      if (this.activeFeedFilter === 'local') {
        return 'Once more members share their city and country, local discovery will light up.'
      }
      if (this.activeFeedFilter === 'selling') {
        return 'No cars are listed for sale yet.'
      }
      return 'No posts are available yet.'
    },
    isPostValid() {
      // Only photos are required to publish
      return this.newPostPreviews.length > 0
    },
    reactionOptions() {
      return REACTION_OPTIONS
    },
    pulseStats() {
      const uniqueMembers = new Set(this.posts.map((post) => post.user_id).filter(Boolean)).size
      return [
        {
          label: 'Live Posts',
          value: this.posts.length.toLocaleString(),
          caption: 'shots, builds and delivery moments',
        },
        {
          label: 'Members Active',
          value: uniqueMembers.toLocaleString(),
          caption: 'people currently shaping the wall',
        },
        {
          label: 'Saved Builds',
          value: Number(this.bookmarkIds.length || 0).toLocaleString(),
          caption: 'bookmarks ready for a second look',
        },
        {
          label: 'Weekly Leaders',
          value: this.weeklyTopMembers.length.toLocaleString(),
          caption: 'members scoring high this week',
        },
      ]
    },
    leadDriver() {
      return this.topUsers[0] || null
    },
    spotlightPost() {
      const candidates = this.posts.filter((post) => !post.is_for_sale)
      if (!candidates.length) return null
      return [...candidates].sort((a, b) => {
        if ((b.likeCount || 0) !== (a.likeCount || 0)) {
          return (b.likeCount || 0) - (a.likeCount || 0)
        }
        return new Date(b.created_at) - new Date(a.created_at)
      })[0]
    },
    weeklyTopMembers() {
      const start = new Date()
      start.setHours(0, 0, 0, 0)
      start.setDate(start.getDate() - start.getDay() + 1)

      const members = new Map()
      this.posts
        .filter((post) => new Date(post.created_at) >= start)
        .forEach((post) => {
          const score = Number(post.likeCount || 0) * 4 + Number(post.totalReactionCount || 0) * 3 + Number(post.viewCount || 0)
          const existing = members.get(post.user_id) || {
            id: post.user_id,
            handle: post.authorHandle,
            fullName: post.authorName,
            avatar: post.authorAvatar,
            initials: post.authorInitials,
            verified: post.authorVerified,
            score: 0,
            likes: 0,
          }
          existing.score += score
          existing.likes += Number(post.likeCount || 0)
          members.set(post.user_id, existing)
        })

      return Array.from(members.values())
        .sort((a, b) => b.score - a.score)
        .slice(0, 5)
        .map((member, index) => ({
          ...member,
          rank: index + 1,
        }))
    },
    buildOfTheWeek() {
      const candidates = this.posts.filter((post) => !post.is_for_sale)
      if (!candidates.length) return null
      return [...candidates]
        .map((post) => ({
          ...post,
          weekScore: Number(post.likeCount || 0) * 4 + Number(post.totalReactionCount || 0) * 3 + Number(post.viewCount || 0),
        }))
        .sort((a, b) => {
          if (b.weekScore !== a.weekScore) return b.weekScore - a.weekScore
          return new Date(b.created_at) - new Date(a.created_at)
        })[0]
    },
    featuredCreators() {
      return this.topUsers.slice(0, 3)
    },
    suggestedMembers() {
      return this.topUsers.filter((user) => user.id !== this.userId && !this.isFollowingAuthor(user.id)).slice(0, 4)
    },
    trendingTags() {
      const counts = new Map()
      this.posts.forEach((post) => {
        (post.tags || []).forEach((tag) => {
          const cleaned = String(tag || '').trim()
          if (!cleaned) return
          counts.set(cleaned, (counts.get(cleaned) || 0) + 1)
        })
      })
      return Array.from(counts.entries())
        .sort((a, b) => b[1] - a[1])
        .slice(0, 6)
        .map(([tag]) => tag)
    },
    dailyPrompt() {
      const prompts = [
        {
          title: 'Cold Start',
          description: 'Pune in fata un motiv clar de postare: startup clip, engine bay, interior night shot sau setup-ul tau preferat pentru condus.',
        },
        {
          title: 'Wheel Check',
          description: 'Micile ritualuri creeaza obsesie. Scoate in evidenta jantele, stance-ul sau un detail shot care spune instant ce vibe are masina.',
        },
        {
          title: 'Garage Mood',
          description: 'Feed-ul prinde viata cand ai teme simple si recurente. Azi merg bine cadrele din garaj, work-in-progress si lumina de seara.',
        },
        {
          title: 'Street Proof',
          description: 'Condu comunitatea spre continut care pare trait, nu doar incarcat. Route photos, rolling shots si opriri spontane merg foarte bine.',
        },
        {
          title: 'Spec Drop',
          description: 'Da un motiv sa se opreasca lumea pe postare: un caption scurt cu motor, putere, mods sau o schimbare noua la build.',
        },
        {
          title: 'For Sale Friday',
          description: 'Cand partea de marketplace se simte activa, produsul pare mai valoros. Pune listari curate si highlight pentru masini reale, bune.',
        },
        {
          title: 'Sunday Spotlight',
          description: 'Incheie saptamana cu un highlight memorabil: cea mai buna poza, cel mai curat build sau un membru care merita impins in fata.',
        },
      ]

      return prompts[new Date().getDay()]
    },
  },
  async mounted() {
    try {
      await this.refreshViewData()
    } finally {
      this.initialLoading = false
      this.$nextTick(() => {
        this.setupFeedObserver()
      })
    }

    this.visibilityHandler = () => {
      if (document.visibilityState === 'visible') {
        this.refreshViewData({ silent: true })
      }
    }
    document.addEventListener('visibilitychange', this.visibilityHandler)
  },
  beforeUnmount() {
    this.teardownFeedObserver()
    this.stopTopUsersDrag()
    if (this.visibilityHandler) {
      document.removeEventListener('visibilitychange', this.visibilityHandler)
      this.visibilityHandler = null
    }
  },
  methods: {
    clearComposeQuery() {
      if (this.$route?.query?.compose !== '1') return
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          compose: undefined,
        },
      })
    },
    async refreshViewData(options = {}) {
      if (this.isRefreshingView) return

      const { silent = false } = options
      this.isRefreshingView = true

      try {
        if (!silent) {
          this.initialLoading = true
        }

        const session = await refreshReadySession()
        this.userId = session?.user?.id || ''
        this.currentUserCreatedAt = session?.user?.created_at || ''
        await this.fetchViewerProfile()
        await this.fetchFollowingIds()
        await this.fetchBookmarks()
        await this.fetchPosts({ reset: true })
        await this.fetchTopUsers()
        this.maybeShowWelcomeModal()
      } finally {
        this.isRefreshingView = false
        if (!silent) {
          this.initialLoading = false
        }
      }
    },
    setupFeedObserver() {
      this.teardownFeedObserver()

      if (typeof window === 'undefined' || typeof IntersectionObserver === 'undefined') return
      if (!this.$refs.feedSentinel) return

      this.feedObserver = new IntersectionObserver((entries) => {
        const entry = entries?.[0]
        if (!entry?.isIntersecting) return
        this.loadMorePosts()
      }, {
        root: null,
        rootMargin: '300px 0px',
        threshold: 0.01,
      })

      this.feedObserver.observe(this.$refs.feedSentinel)
    },
    teardownFeedObserver() {
      if (this.feedObserver) {
        this.feedObserver.disconnect()
        this.feedObserver = null
      }
    },
    startTopUsersDrag(event) {
      if (event.pointerType === 'touch') return
      if (event.button !== 0) return

      const scroller = this.$refs.topUsersScroller
      if (!scroller) return

      this.topUsersDrag = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startScrollLeft: scroller.scrollLeft,
      }
      this.topUsersDragged = false
      scroller.classList.add('is-dragging')
      scroller.setPointerCapture?.(event.pointerId)
      window.addEventListener('pointermove', this.handleTopUsersDragMove)
      window.addEventListener('pointerup', this.stopTopUsersDrag)
      window.addEventListener('pointercancel', this.stopTopUsersDrag)
    },
    handleTopUsersDragMove(event) {
      if (!this.topUsersDrag) return

      const scroller = this.$refs.topUsersScroller
      if (!scroller) return

      const deltaX = event.clientX - this.topUsersDrag.startX
      if (Math.abs(deltaX) > 4) {
        this.topUsersDragged = true
      }

      scroller.scrollLeft = this.topUsersDrag.startScrollLeft - deltaX
    },
    stopTopUsersDrag() {
      const scroller = this.$refs.topUsersScroller
      if (scroller) {
        scroller.classList.remove('is-dragging')
      }

      this.topUsersDrag = null
      window.removeEventListener('pointermove', this.handleTopUsersDragMove)
      window.removeEventListener('pointerup', this.stopTopUsersDrag)
      window.removeEventListener('pointercancel', this.stopTopUsersDrag)

      if (this.topUsersDragged) {
        window.setTimeout(() => {
          this.topUsersDragged = false
        }, 0)
      }
    },
    handleTopUserCardClick(event) {
      if (!this.topUsersDragged) return
      event.preventDefault()
      event.stopPropagation()
    },
    normalizePost(post) {
      const profile = post.profiles || {}
      const authorAvatar = getAvatarUrl({ avatarPath: profile.avatar_path, avatarUrl: profile.avatar_url })

      const mediaItems = [
        {
          url: post.image_path
            ? getPostImageUrl({ imagePath: post.image_path, imageUrl: post.image_url })
            : post.image_url,
          offset: {
            x: Number.isFinite(post.image_offset_x) ? post.image_offset_x : 50,
            y: Number.isFinite(post.image_offset_y) ? post.image_offset_y : 50,
          },
        },
        ...(post.post_media || []).map((item) => ({
          url: item.image_path
            ? getPostImageUrl({ imagePath: item.image_path, imageUrl: item.image_url })
            : item.image_url,
          offset: {
            x: Number.isFinite(item.offset_x) ? item.offset_x : 50,
            y: Number.isFinite(item.offset_y) ? item.offset_y : 50,
          },
        })),
      ].filter((item) => Boolean(item.url))

      const mediaUrls = mediaItems.map((item) => item.url)
      const mediaOffsets = mediaItems.map((item) => item.offset)

      const normalized = {
        ...post,
        authorName: profile.full_name || 'DRVN Member',
        authorHandle: profile.handle || 'member',
        authorVerified: Boolean(profile.verified),
        authorTier: profile.member_tier || 'member',
        authorCountry: profile.country || '',
        authorCity: profile.city || '',
        authorAvatar,
        authorInitials: (profile.full_name || 'D')
          .split(' ')
          .filter(Boolean)
          .slice(0, 2)
          .map((chunk) => chunk[0].toUpperCase())
          .join(''),
        createdLabel: new Date(post.created_at).toLocaleDateString(),
        mediaUrls,
        mediaOffsets,
        mediaIndex: 0,
        mediaDirection: 'next',
        likeCount: 0,
        viewCount: 0,
        commentCount: 0,
        isLiked: false,
        reactionCounts: {},
        totalReactionCount: 0,
        userReaction: '',
        newComment: '',
        isBookmarked: this.isBookmarked(post.id),
      }

      this.preloadMedia(normalized.mediaUrls, normalized.mediaIndex || 0)
      return normalized
    },
    async hydratePostMeta(posts) {
      const postIds = posts.map((post) => post.id).filter(Boolean)
      if (!postIds.length) return posts

      const [{ data: likes }, { data: comments }, { data: reactions }, { data: views }, { data: bookmarks }] = await Promise.all([
        runSupabaseQueryWithRetry(() => (
          supabase
            .from('post_likes')
            .select('post_id, user_id')
            .in('post_id', postIds)
        )),
        runSupabaseQueryWithRetry(() => (
          supabase
            .from('post_comments')
            .select('post_id')
            .in('post_id', postIds)
        )),
        runSupabaseQueryWithRetry(() => (
          supabase
            .from('post_reactions')
            .select('post_id, user_id, reaction_type')
            .in('post_id', postIds)
        )),
        runSupabaseQueryWithRetry(() => (
          supabase
            .from('post_views')
            .select('post_id')
            .in('post_id', postIds)
        )),
        runSupabaseQueryWithRetry(() => (
          supabase
            .from('post_bookmarks')
            .select('post_id')
            .in('post_id', postIds)
        )),
      ])

      posts.forEach((post) => {
        const postReactions = (reactions || []).filter((reaction) => reaction.post_id === post.id)
        const reactionCounts = REACTION_OPTIONS.reduce((acc, reaction) => ({
          ...acc,
          [reaction.type]: postReactions.filter((entry) => entry.reaction_type === reaction.type).length,
        }), {})

        post.likeCount = likes?.filter((like) => like.post_id === post.id).length || 0
        post.viewCount = views?.filter((view) => view.post_id === post.id).length || 0
        post.commentCount = comments?.filter((comment) => comment.post_id === post.id).length || 0
        post.saveCount = bookmarks?.filter((bookmark) => bookmark.post_id === post.id).length || 0
        post.isLiked = Boolean(likes?.some((like) => like.post_id === post.id && like.user_id === this.userId))
        post.reactionCounts = reactionCounts
        post.totalReactionCount = postReactions.length
        post.userReaction = postReactions.find((reaction) => reaction.user_id === this.userId)?.reaction_type || ''
      })

      return posts
    },
    reactionLabel(type) {
      return REACTION_OPTIONS.find((reaction) => reaction.type === type)?.label || 'Reaction'
    },
    getReactionCount(post, type) {
      return Number(post?.reactionCounts?.[type] || 0)
    },
    reactionButtonClass(post, type) {
      const isActive = post?.userReaction === type
      if (isActive) {
        return 'border-neon-400/50 bg-neon-400/10 text-white shadow-[0_0_0_1px_rgba(125,249,255,0.14)]'
      }
      return 'border-white/10 bg-white/[0.03] text-steel-300 hover:border-white/25 hover:bg-white/[0.06] hover:text-white'
    },
    async loadMorePosts() {
      if (this.initialLoading || this.loadingMorePosts || !this.hasMorePosts) return
      await this.fetchPosts({ reset: false })
    },
    maybeShowWelcomeModal() {
      if (!this.userId || !this.currentUserCreatedAt) return

      const createdAt = new Date(this.currentUserCreatedAt).getTime()
      if (!Number.isFinite(createdAt)) return

      const daysSinceSignup = (Date.now() - createdAt) / (1000 * 60 * 60 * 24)
      if (daysSinceSignup > 7) return

      const storageKey = `drvn-feed-welcome-dismissed:${this.userId}`
      if (window.localStorage.getItem(storageKey) === 'true') return

      this.showWelcomeModal = true
    },
    dismissWelcomeModal() {
      if (this.userId) {
        window.localStorage.setItem(`drvn-feed-welcome-dismissed:${this.userId}`, 'true')
      }
      this.showWelcomeModal = false
    },
    shouldShowFollowButton(authorId) {
      return Boolean(this.followFeatureReady && this.userId && authorId && authorId !== this.userId)
    },
    isBookmarked(postId) {
      return this.bookmarkIds.includes(postId)
    },
    isLocalPost(post) {
      const country = this.viewerProfile?.country || ''
      const city = this.viewerProfile?.city || ''
      if (city && post.authorCity && city.toLowerCase() === String(post.authorCity).toLowerCase()) return true
      if (country && post.authorCountry && country.toLowerCase() === String(post.authorCountry).toLowerCase()) return true
      return false
    },
    normalizePostTags(rawValue) {
      return String(rawValue || '')
        .split(',')
        .map((tag) => tag.trim().replace(/^#/, ''))
        .filter(Boolean)
        .slice(0, 8)
    },
    postMetaBadges(post) {
      const badges = []
      if (post.status && post.status !== 'active') {
        badges.push({
          label: post.status,
          tone: post.status === 'featured'
            ? 'border-amber-400/40 bg-amber-400/10 text-amber-200'
            : 'border-sky-400/40 bg-sky-400/10 text-sky-300',
        })
      }
      if (post.authorTier && post.authorTier !== 'member') {
        badges.push({
          label: post.authorTier,
          tone: post.authorTier === 'business'
            ? 'border-fuchsia-400/35 bg-fuchsia-400/10 text-fuchsia-200'
            : 'border-neon-400/35 bg-neon-400/10 text-neon-300',
        })
      }
      if (post.is_for_sale) {
        badges.push({
          label: 'for sale',
          tone: 'border-emerald-400/35 bg-emerald-400/10 text-emerald-200',
        })
      }
      return badges
    },
    applyTagFilter(tag) {
      this.discoveryQuery = tag
      this.activeFeedFilter = 'feed'
    },
    async fetchViewerProfile() {
      if (!this.userId) {
        this.viewerProfile = null
        return
      }

      const { data } = await runSupabaseQueryWithRetry(() => (
        supabase
          .from('profiles')
          .select('country, city')
          .eq('id', this.userId)
          .maybeSingle()
      ))

      this.viewerProfile = data || null
    },
    isFollowingAuthor(authorId) {
      if (!authorId) return false
      if (authorId === this.userId) return true
      return this.followingIds.includes(authorId)
    },
    async fetchBookmarks() {
      if (!this.userId) {
        this.bookmarkIds = []
        return
      }

      const { data, error } = await runSupabaseQueryWithRetry(() => (
        supabase
          .from('post_bookmarks')
          .select('post_id')
          .eq('user_id', this.userId)
      ))

      if (error) {
        this.bookmarkIds = []
        return
      }

      this.bookmarkIds = (data || []).map((entry) => entry.post_id).filter(Boolean)
    },
    async fetchFollowingIds() {
      if (!this.userId) {
        this.followingIds = []
        return
      }

      const { data, error } = await supabase
        .from('user_follows')
        .select('following_id')
        .eq('follower_id', this.userId)

      if (error) {
        this.followFeatureReady = false
        this.followingIds = []
        return
      }

      this.followFeatureReady = true
      this.followingIds = (data || []).map((entry) => entry.following_id).filter(Boolean)
    },
    async toggleFollow(post) {
      if (!this.userId) {
        this.errorMessage = 'Please sign in to follow members.'
        return
      }

      if (!this.followFeatureReady) {
        this.errorMessage = 'Follow data will appear after the follow table is set up.'
        return
      }

      if (!post?.user_id || post.user_id === this.userId) return

      this.errorMessage = ''
      const isFollowing = this.isFollowingAuthor(post.user_id)

      if (isFollowing) {
        const { error } = await supabase
          .from('user_follows')
          .delete()
          .eq('follower_id', this.userId)
          .eq('following_id', post.user_id)

        if (error) {
          this.errorMessage = error.message || 'Unable to update follow status.'
          return
        }

        this.followingIds = this.followingIds.filter((id) => id !== post.user_id)
        this.statusMessage = `Unfollowed @${post.authorHandle}`
        emitAppToast({ title: 'Follow updated', message: `Unfollowed @${post.authorHandle}.`, tone: 'info' })
        return
      }

      const { error } = await supabase.from('user_follows').insert({
        follower_id: this.userId,
        following_id: post.user_id,
      })

      if (error) {
        this.errorMessage = error.message || 'Unable to follow this member.'
        return
      }

      this.followingIds = [...new Set([...this.followingIds, post.user_id])]
      this.statusMessage = `Following @${post.authorHandle}`
      emitAppToast({ title: 'Following', message: `You are now following @${post.authorHandle}.`, tone: 'success' })
    },
    async toggleBookmark(post) {
      if (!this.userId) {
        this.errorMessage = 'Please sign in to save posts.'
        return
      }

      const isSaved = this.isBookmarked(post.id)
      this.errorMessage = ''

      if (isSaved) {
        const { error } = await supabase
          .from('post_bookmarks')
          .delete()
          .eq('user_id', this.userId)
          .eq('post_id', post.id)

        if (error) {
          this.errorMessage = error.message || 'Unable to remove saved post.'
          return
        }

        this.bookmarkIds = this.bookmarkIds.filter((id) => id !== post.id)
        post.isBookmarked = false
        post.saveCount = Math.max(0, Number(post.saveCount || 0) - 1)
        emitAppToast({ title: 'Removed from saved', message: 'Post removed from your saved list.', tone: 'info' })
        return
      }

      const { error } = await supabase
        .from('post_bookmarks')
        .upsert({
          user_id: this.userId,
          post_id: post.id,
        }, {
          onConflict: 'user_id,post_id',
        })

      if (error) {
        this.errorMessage = error.message || 'Unable to save post.'
        return
      }

      this.bookmarkIds = [...new Set([...this.bookmarkIds, post.id])]
      post.isBookmarked = true
      post.saveCount = Number(post.saveCount || 0) + 1
      emitAppToast({ title: 'Saved', message: 'Post added to your saved builds.', tone: 'success' })
      await this.notifyPostOwner(post, 'post_save')
    },
    openReportModal(post) {
      this.reportPost = post
      this.reportReason = ''
      this.reportError = ''
      this.reportStatus = ''
      this.showReportModal = true
    },
    closeReportModal() {
      this.showReportModal = false
      this.reportPost = null
      this.reportReason = ''
      this.reportError = ''
      this.reportStatus = ''
      this.reportSubmitting = false
    },
    async submitReport() {
      if (!this.userId) {
        this.reportError = 'Please sign in to report posts.'
        return
      }
      if (!this.reportPost?.id) {
        this.reportError = 'Post not found.'
        return
      }

      const reason = this.reportReason.trim()
      if (!reason) return

      this.reportSubmitting = true
      this.reportError = ''
      this.reportStatus = ''

      const { error } = await supabase.from('post_reports').insert({
        post_id: this.reportPost.id,
        reporter_id: this.userId,
        reason,
      })

      this.reportSubmitting = false

      if (error) {
        this.reportError = error.message || 'Unable to submit report.'
        return
      }

      this.reportStatus = 'Report sent. Thank you.'
      setTimeout(() => this.closeReportModal(), 1200)
    },
    async fetchPosts(options = {}) {
      const { reset = false } = options
      this.errorMessage = ''
      if (reset) {
        this.feedPage = 0
        this.hasMorePosts = true
      } else {
        if (!this.hasMorePosts || this.loadingMorePosts) return
        this.loadingMorePosts = true
      }

      const from = this.feedPage * this.pageSize
      const to = from + this.pageSize - 1

      const { data, error } = await runSupabaseQueryWithRetry(() => (
        supabase
          .from('posts')
          .select(
            'id, caption, description, modifications, engine, hp_stock, hp_tuned, year, is_for_sale, car_make, car_model, tags, status, edited_at, image_url, image_path, image_offset_x, image_offset_y, created_at, user_id, profiles (handle, full_name, avatar_url, avatar_path, verified, member_tier, country, city), post_media (image_url, image_path, sort_order, offset_x, offset_y)'
          )
          .order('created_at', { ascending: false })
          .range(from, to)
      ))

      if (error) {
        this.errorMessage = getReadableSupabaseErrorMessage(error, 'Unable to load feed yet.')
        this.loadingMorePosts = false
        return
      }

      const incomingPosts = await this.hydratePostMeta((data || []).map((post) => this.normalizePost(post)))

      if (reset) {
        this.posts = incomingPosts
      } else {
        const existingIds = new Set(this.posts.map((post) => post.id))
        this.posts = [...this.posts, ...incomingPosts.filter((post) => !existingIds.has(post.id))]
      }

      this.hasMorePosts = incomingPosts.length === this.pageSize
      if (incomingPosts.length) {
        this.feedPage += 1
      }
      this.loadingMorePosts = false

      this.$nextTick(() => {
        this.setupFeedObserver()
      })
    },
    currentMedia(post) {
      if (!post.mediaUrls || post.mediaUrls.length === 0) return ''
      const index = post.mediaIndex || 0
      return post.mediaUrls[index]
    },
    currentMediaPosition(post) {
      if (!post.mediaOffsets || post.mediaOffsets.length === 0) return '50% 50%'
      const index = post.mediaIndex || 0
      const offset = post.mediaOffsets[index] || { x: 50, y: 50 }
      return `${offset.x}% ${offset.y}%`
    },
    previewPosition(idx) {
      const offset = this.newPostOffsets[idx] || { x: 50, y: 50 }
      return `${offset.x}% ${offset.y}%`
    },
    startPreviewDrag(idx, event) {
      event.preventDefault()
      if (!this.newPostOffsets[idx]) {
        this.newPostOffsets[idx] = { x: 50, y: 50 }
      }
      const target = event.currentTarget
      if (!target) return
      if (typeof target.setPointerCapture === 'function') {
        try {
          target.setPointerCapture(event.pointerId)
        } catch (e) {
          // ignore if capture fails
        }
      }
      const rect = target.getBoundingClientRect()
      const startOffset = this.newPostOffsets[idx]
      this.previewDrag = {
        idx,
        startX: event.clientX,
        startY: event.clientY,
        startOffsetX: startOffset.x,
        startOffsetY: startOffset.y,
        width: rect.width || 1,
        height: rect.height || 1,
      }
      const onMove = (moveEvent) => {
        if (!this.previewDrag) return
        moveEvent.preventDefault()
        const dx = moveEvent.clientX - this.previewDrag.startX
        const dy = moveEvent.clientY - this.previewDrag.startY
        const nextX = this.previewDrag.startOffsetX + (dx / this.previewDrag.width) * 100
        const nextY = this.previewDrag.startOffsetY + (dy / this.previewDrag.height) * 100
        this.newPostOffsets[this.previewDrag.idx] = {
          x: Math.max(0, Math.min(100, Math.round(nextX))),
          y: Math.max(0, Math.min(100, Math.round(nextY))),
        }
      }
      const onUp = () => {
        window.removeEventListener('pointermove', onMove)
        window.removeEventListener('pointerup', onUp)
        this.previewDrag = null
      }
      window.addEventListener('pointermove', onMove, { passive: false })
      window.addEventListener('pointerup', onUp)
    },
    preloadMedia(urls, index = 0) {
      if (!urls || !urls.length) return
      const candidates = [index, index + 1, index - 1]
        .filter((i) => i >= 0 && i < urls.length)
        .map((i) => urls[i])
        .filter(Boolean)

      candidates.forEach((url) => {
        if (this.preloadedImages[url]) return
        const img = new Image()
        img.decoding = 'async'
        img.src = url
        this.preloadedImages[url] = true
      })
    },
    setMediaIndex(post, idx) {
      if (!post?.mediaUrls || idx < 0 || idx >= post.mediaUrls.length) return
      post.mediaDirection = idx > (post.mediaIndex || 0) ? 'next' : 'prev'
      post.mediaIndex = idx
      this.preloadMedia(post.mediaUrls, post.mediaIndex || 0)
    },
    handleSwipeStart(e) {
      this.swipeStartX = e.changedTouches[0].clientX
      this.swipeStartY = e.changedTouches[0].clientY
    },
    handleSwipeEnd(e, post) {
      this.swipeEndX = e.changedTouches[0].clientX
      this.swipeEndY = e.changedTouches[0].clientY
      if (!post.mediaUrls || post.mediaUrls.length <= 1) return
      
      const swipeThreshold = 50
      const diffX = this.swipeStartX - this.swipeEndX
      const diffY = Math.abs(this.swipeStartY - this.swipeEndY)
      
      // Only navigate carousel if horizontal movement is greater than vertical movement
      if (Math.abs(diffX) > swipeThreshold && Math.abs(diffX) > diffY) {
        if (diffX > 0) {
          this.navigateToNext(post)
        } else {
          this.navigateToPrevious(post)
        }
      }
    },
    navigateToNext(post) {
      if (!post.mediaUrls || post.mediaUrls.length <= 1) return
      post.mediaDirection = 'next'
      post.mediaIndex = (post.mediaIndex || 0) + 1
      if (post.mediaIndex >= post.mediaUrls.length) {
        post.mediaIndex = 0
      }
      this.preloadMedia(post.mediaUrls, post.mediaIndex || 0)
      this.$forceUpdate()
    },
    navigateToPrevious(post) {
      if (!post.mediaUrls || post.mediaUrls.length <= 1) return
      post.mediaDirection = 'prev'
      post.mediaIndex = (post.mediaIndex || 1) - 1
      if (post.mediaIndex < 0) {
        post.mediaIndex = post.mediaUrls.length - 1
      }
      this.preloadMedia(post.mediaUrls, post.mediaIndex || 0)
      this.$forceUpdate()
    },
    async toggleLike(post) {
      if (!this.userId) {
        this.errorMessage = 'Please sign in to like posts.'
        return
      }

      if (post.isLiked) {
        await supabase
          .from('post_likes')
          .delete()
          .eq('post_id', post.id)
          .eq('user_id', this.userId)
        post.isLiked = false
        post.likeCount = Math.max(0, post.likeCount - 1)
      } else {
        await supabase.from('post_likes').insert({ post_id: post.id, user_id: this.userId })
        post.isLiked = true
        post.likeCount += 1
        await this.notifyPostOwner(post, 'post_like')
      }

      // refresh the top users list since like counts changed
      await this.fetchTopUsers()
    },
    async toggleReaction(post, reactionType) {
      if (!this.userId) {
        this.errorMessage = 'Please sign in to react to posts.'
        return
      }

      if (!post?.id) return

      const previousReaction = post.userReaction || ''
      this.errorMessage = ''

      if (previousReaction === reactionType) {
        const { error } = await supabase
          .from('post_reactions')
          .delete()
          .eq('post_id', post.id)
          .eq('user_id', this.userId)

        if (error) {
          this.errorMessage = error.message || 'Unable to remove reaction.'
          return
        }

        post.reactionCounts = {
          ...(post.reactionCounts || {}),
          [reactionType]: Math.max(0, this.getReactionCount(post, reactionType) - 1),
        }
        post.totalReactionCount = Math.max(0, Number(post.totalReactionCount || 0) - 1)
        post.userReaction = ''
        return
      }

      const { error } = await supabase
        .from('post_reactions')
        .upsert({
          post_id: post.id,
          user_id: this.userId,
          reaction_type: reactionType,
        }, {
          onConflict: 'post_id,user_id',
        })

      if (error) {
        this.errorMessage = error.message || 'Unable to save reaction.'
        return
      }

      const nextCounts = {
        ...(post.reactionCounts || {}),
      }

      if (previousReaction) {
        nextCounts[previousReaction] = Math.max(0, Number(nextCounts[previousReaction] || 0) - 1)
      } else {
        post.totalReactionCount = Number(post.totalReactionCount || 0) + 1
      }

      nextCounts[reactionType] = Number(nextCounts[reactionType] || 0) + 1
      post.reactionCounts = nextCounts
      post.userReaction = reactionType

      await this.notifyPostReaction(post, reactionType)
    },
    async addComment(post) {
      if (!this.userId) {
        this.errorMessage = 'Please sign in to comment.'
        return
      }

      if (!post.newComment) return

      const { error } = await supabase.from('post_comments').insert({
        post_id: post.id,
        user_id: this.userId,
        content: post.newComment,
      })

      if (error) {
        this.errorMessage = error.message
        return
      }

      post.commentCount += 1
      post.newComment = ''
      await this.notifyPostOwner(post, 'post_comment')
    },
    async notifyPostOwner(post, type) {
      if (!post?.user_id || post.user_id === this.userId) return
      await createUserNotification({
        recipientId: post.user_id,
        actorId: this.userId,
        postId: post.id,
        type,
      })
    },
    async notifyPostReaction(post, reactionType) {
      if (!post?.user_id || post.user_id === this.userId) return
      await createUserNotification({
        recipientId: post.user_id,
        actorId: this.userId,
        postId: post.id,
        type: `post_reaction_${reactionType}`,
      })
    },
    async sharePost(post) {
      this.errorMessage = ''
      this.statusMessage = ''
      const postUrl = `${window.location.origin}/post/${post.id}`

      const ok = await this.copyTextToClipboard(postUrl)
      if (ok) {
        this.statusMessage = 'Post link copied to clipboard.'
        emitAppToast({ title: 'Link copied', message: 'Post link copied to clipboard.', tone: 'success' })
      } else {
        this.errorMessage = 'Unable to copy link. ' + postUrl
      }

      setTimeout(() => (this.statusMessage = ''), 3000)
    },

    async copyTextToClipboard(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
          await navigator.clipboard.writeText(text)
          return true
        } catch (e) {
          // fall through to legacy fallback
        }
      }

      try {
        const el = document.createElement('textarea')
        el.value = text
        el.setAttribute('readonly', '')
        el.style.position = 'absolute'
        el.style.left = '-9999px'
        document.body.appendChild(el)

        const selection = document.getSelection()
        const range = selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : null
        el.select()
        const success = document.execCommand('copy')
        document.body.removeChild(el)

        if (range && selection) {
          selection.removeAllRanges()
          selection.addRange(range)
        }

        return success
      } catch (e) {
        return false
      }
    },
    closeLikesModal() {
      this.showLikesModal = false
      this.likesUsers = []
      this.likesError = ''
      this.likesLoading = false
    },
    async openLikesModal(post) {
      this.showLikesModal = true
      this.likesLoading = true
      this.likesError = ''
      this.likesUsers = []

      const { data: likes, error } = await supabase
        .from('post_likes')
        .select('user_id')
        .eq('post_id', post.id)

      if (error) {
        this.likesError = 'Unable to load likes.'
        this.likesLoading = false
        return
      }

      const userIds = (likes || []).map((like) => like.user_id).filter(Boolean)
      if (!userIds.length) {
        this.likesUsers = []
        this.likesLoading = false
        return
      }

      const { data: profiles, error: profileError } = await supabase
        .from('profiles')
        .select('id, handle, full_name, avatar_url, avatar_path, verified')
        .in('id', userIds)

      if (profileError) {
        this.likesError = 'Unable to load likes.'
        this.likesLoading = false
        return
      }

      const profileMap = new Map((profiles || []).map((profile) => [profile.id, profile]))

      this.likesUsers = userIds.map((userId) => {
        const profile = profileMap.get(userId) || {}
        const avatar = getAvatarUrl({ avatarPath: profile.avatar_path, avatarUrl: profile.avatar_url })
        const fullName = profile.full_name || 'DRVN Member'
        const handle = profile.handle || 'member'
        const initials = fullName
          .split(' ')
          .filter(Boolean)
          .slice(0, 2)
          .map((chunk) => chunk[0].toUpperCase())
          .join('')
        return {
          id: userId,
          handle,
          fullName,
          avatar,
          initials,
          verified: Boolean(profile.verified),
        }
      })
      this.likesLoading = false
    },
    openNewPostModal() {
      this.showNewPostModal = true
      this.statusMessage = ''
      this.errorMessage = ''
    },
    resetNewPostFileInput() {
      const input = this.$refs.newPostFileInput
      if (input) {
        input.value = ''
      }
    },
    closeNewPostModal() {
      this.showNewPostModal = false
      this.statusMessage = ''
      this.errorMessage = ''
      this.newPostCaption = ''
      this.newPostDescription = ''
      this.newPostModifications = ''
      this.newPostEngine = ''
      this.newPostMake = ''
      this.newPostModel = ''
      this.newPostTags = ''
      this.newPostStatus = 'active'
      this.newPostHpStock = null
      this.newPostHpTuned = null
      this.newPostYear = null
      this.newPostForSale = false
      this.newPostPreviews = []
      this.newPostPaths = []
      this.newPostOffsets = []
      this.isPosting = false
      this.resetNewPostFileInput()
    },
    async convertImageToWebp(file, { maxWidth, quality = 0.72, maxPixels = 1400000 }) {
      const objectUrl = URL.createObjectURL(file)
      const image = await new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => {
          URL.revokeObjectURL(objectUrl)
          resolve(img)
        }
        img.onerror = () => {
          URL.revokeObjectURL(objectUrl)
          reject(new Error('Image decode failed.'))
        }
        img.src = objectUrl
      })

      const originalWidth = image.width || 1
      const originalHeight = image.height || 1
      const widthScale = Math.min(1, maxWidth / originalWidth)
      const pixelScale = Math.min(1, Math.sqrt(maxPixels / (originalWidth * originalHeight || 1)))
      const scale = Math.min(widthScale, pixelScale)
      const targetWidth = Math.max(1, Math.round(originalWidth * scale))
      const targetHeight = Math.max(1, Math.round(originalHeight * scale))

      const canvas = document.createElement('canvas')
      canvas.width = targetWidth
      canvas.height = targetHeight
      const ctx = canvas.getContext('2d')
      ctx.imageSmoothingEnabled = true
      ctx.imageSmoothingQuality = 'high'
      ctx.drawImage(image, 0, 0, targetWidth, targetHeight)

      const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/webp', quality))
      if (!blob) throw new Error('Image conversion failed.')

      return new File([blob], file.name.replace(/\.[^.]+$/, '.webp'), { type: 'image/webp' })
    },
    async handlePostUpload(event) {
      const input = event?.target
      const files = Array.from(input?.files || [])

      try {
        if (!files.length) return

        if (files.length > 5) {
          this.errorMessage = 'You can upload up to 5 photos.'
          return
        }

        this.errorMessage = ''
        this.statusMessage = ''

        const userId = this.userId
        if (!userId) {
          this.errorMessage = 'Please sign in to upload a post.'
          return
        }

        this.newPostPreviews = []
        this.newPostPaths = []
        this.newPostOffsets = []

        for (const file of files) {
          if (!file.type.startsWith('image/')) {
            this.errorMessage = 'Only image files can be uploaded.'
            return
          }

          let uploadFile = file
          try {
            uploadFile = await this.convertImageToWebp(file, { maxWidth: 1280, quality: 0.72, maxPixels: 1200000 })
          } catch (error) {
            this.errorMessage = 'One of the photos could not be processed. Try a JPG or PNG image.'
            return
          }

          const safeName = file.name.replace(/[^a-zA-Z0-9.\-_]/g, '').replace(/\.[^.]+$/, '.webp')
          const filePath = `${userId}/${Date.now()}-${safeName}`

          const { error: uploadError } = await supabase.storage
            .from('posts')
            .upload(filePath, uploadFile, { upsert: false, contentType: 'image/webp', cacheControl: '31536000' })

          if (uploadError) {
            this.errorMessage = 'Post upload failed. Make sure the "posts" bucket exists.'
            return
          }

          this.newPostPaths.push(filePath)
          this.newPostPreviews.push(getPostImageUrl({ imagePath: filePath }))
          this.newPostOffsets.push({ x: 50, y: 50 })
        }

        this.statusMessage = 'Photos uploaded. Publish when ready.'
        emitAppToast({ title: 'Photos ready', message: 'Your upload finished successfully.', tone: 'success' })
      } finally {
        if (input) {
          input.value = ''
        }
        this.resetNewPostFileInput()
      }
    },
    async publishPost() {
      if (!this.isPostValid) {
        this.errorMessage = 'Please add at least one photo to publish.'
        return
      }

      this.isPosting = true
      this.errorMessage = ''
      this.statusMessage = ''

      const userId = this.userId
      if (!userId) {
        this.errorMessage = 'Please sign in to publish.'
        this.isPosting = false
        return
      }

      const { data: postRow, error } = await supabase
        .from('posts')
        .insert({
          user_id: userId,
          caption: this.newPostCaption,
          description: this.newPostDescription,
          modifications: this.newPostModifications,
          engine: this.newPostEngine,
          car_make: this.newPostMake,
          car_model: this.newPostModel,
          tags: this.normalizePostTags(this.newPostTags),
          status: this.newPostStatus,
          hp_stock: this.newPostHpStock,
          hp_tuned: this.newPostHpTuned,
          year: this.newPostYear,
          is_for_sale: this.newPostForSale,
          image_url: this.newPostPreviews[0],
          image_path: this.newPostPaths[0],
          image_offset_x: this.newPostOffsets[0]?.x ?? 50,
          image_offset_y: this.newPostOffsets[0]?.y ?? 50,
        })
        .select('id')
        .single()

      this.isPosting = false

      if (error) {
        this.errorMessage = error.message
        return
      }

      if (postRow?.id && this.newPostPaths.length > 1) {
        const mediaRows = this.newPostPaths.slice(1).map((path, index) => ({
          post_id: postRow.id,
          image_path: path,
          image_url: this.newPostPreviews[index + 1],
          sort_order: index + 1,
          offset_x: this.newPostOffsets[index + 1]?.x ?? 50,
          offset_y: this.newPostOffsets[index + 1]?.y ?? 50,
        }))
        await supabase.from('post_media').insert(mediaRows)
      }

      // reset and refresh
      this.closeNewPostModal()
      this.statusMessage = 'Post published.'
      emitAppToast({ title: 'Post published', message: 'Your build is now live on the wall.', tone: 'success' })
      await this.fetchFollowingIds()
      await this.fetchBookmarks()
      await this.fetchPosts({ reset: true })
      await this.fetchTopUsers()
    },

    async fetchTopUsers() {
      this.topUsersLoading = true
      try {
        // fetch posts with their likes aggregated per post
        const { data: posts, error } = await supabase.from('posts').select('user_id, post_likes (id)')
        if (error) {
          this.topUsers = []
          this.topUsersLoading = false
          return
        }

        const likeMap = new Map()
        ;(posts || []).forEach((p) => {
          const userId = p.user_id
          const count = (p.post_likes || []).length || 0
          likeMap.set(userId, (likeMap.get(userId) || 0) + count)
        })

        const usersSorted = Array.from(likeMap.entries())
          .map(([userId, count]) => ({ userId, count }))
          .sort((a, b) => b.count - a.count)
          .slice(0, 5)

        if (!usersSorted.length) {
          this.topUsers = []
          this.topUsersLoading = false
          return
        }

        const userIds = usersSorted.map((u) => u.userId)
        const { data: profiles } = await supabase
          .from('profiles')
          .select('id, handle, full_name, avatar_url, avatar_path, verified, member_tier, country, city')
          .in('id', userIds)

        const profileMap = new Map((profiles || []).map((p) => [p.id, p]))

        this.topUsers = usersSorted.map((u, idx) => {
          const profile = profileMap.get(u.userId) || {}
          const avatar = getAvatarUrl({ avatarPath: profile.avatar_path, avatarUrl: profile.avatar_url })
          const fullName = profile.full_name || 'DRVN Member'
          const initials = fullName
            .split(' ')
            .filter(Boolean)
            .slice(0, 2)
            .map((c) => c[0].toUpperCase())
            .join('')
          return {
            id: u.userId,
            handle: profile.handle || 'member',
            fullName,
            avatar,
            initials,
            verified: Boolean(profile.verified),
            memberTier: profile.member_tier || 'member',
            country: profile.country || '',
            city: profile.city || '',
            likeCount: u.count,
            rank: idx + 1,
          }
        })
      } catch (e) {
        this.topUsers = []
      }

      this.topUsersLoading = false
    }
  },
}
</script>

<style>
/* hide horizontal scrollbar for the Top Members scroller across browsers */
.no-scrollbar {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.no-scrollbar::-webkit-scrollbar {
  height: 0;
  display: none; /* Safari and Chrome */
}

.top-users-scroller {
  cursor: grab;
}

.top-users-scroller.is-dragging {
  cursor: grabbing;
  user-select: none;
}

.top-users-scroller.is-dragging a {
  pointer-events: none;
}

.media-swipe-next-enter-active,
.media-swipe-next-leave-active,
.media-swipe-prev-enter-active,
.media-swipe-prev-leave-active {
  transition: opacity 220ms ease, transform 220ms ease;
}

.media-swipe-next-enter-from {
  opacity: 0;
  transform: translateX(10%);
}

.media-swipe-next-leave-to {
  opacity: 0;
  transform: translateX(-10%);
}

.media-swipe-prev-enter-from {
  opacity: 0;
  transform: translateX(-10%);
}

.media-swipe-prev-leave-to {
  opacity: 0;
  transform: translateX(10%);
}

.theme-light .feed-premium-card {
  border-color: rgba(148, 163, 184, 0.24) !important;
  box-shadow: 0 18px 50px rgba(148, 163, 184, 0.18), 0 0 0 1px rgba(255, 255, 255, 0.55) inset;
}

.theme-light .feed-build-card {
  background:
    radial-gradient(circle at top left, rgba(245, 158, 11, 0.16), transparent 34%),
    linear-gradient(155deg, rgba(255, 255, 255, 0.98), rgba(241, 245, 249, 0.96)) !important;
}

.theme-light .feed-leaderboard-card {
  background:
    radial-gradient(circle at top right, rgba(59, 130, 246, 0.12), transparent 30%),
    linear-gradient(160deg, rgba(255, 255, 255, 0.98), rgba(236, 242, 248, 0.96)) !important;
}

.theme-light .feed-premium-inner,
.theme-light .feed-leaderboard-row {
  background: rgba(255, 255, 255, 0.72) !important;
  border-color: rgba(148, 163, 184, 0.24) !important;
  box-shadow: 0 8px 24px rgba(148, 163, 184, 0.12);
}

.theme-light .feed-premium-inner:hover,
.theme-light .feed-leaderboard-row:hover {
  border-color: rgba(59, 130, 246, 0.22) !important;
  background: rgba(255, 255, 255, 0.88) !important;
}
</style>
